import _default from './commaListsAnd';
export { _default as default };
